import { installSearchSelects } from '@/shared/selects/plugin'
import { mapearTeclasSelect } from '@/utils/selectTeclado'
import lancamentoLimpavel from '@/directives/lancamentoLimpavel'
import ResumoEstoqueUnidades from '@/components/produtos/ResumoEstoqueUnidades.vue'
import Vue from 'vue'
import produtoChave from '@/directives/produtoChave'
Vue.directive('produto-chave', produtoChave)
import App from './App.vue'
import router from './router'
import Relationships from '@/shared/relationships/plugin'
import EditingGuard from './plugins/editingGuard'
import whatsappHelper from './utils/whatsappHelper'
import { registerRelatedRegistrations } from './services/relatedRegistrations'
Vue.use(Relationships)
registerRelatedRegistrations(Vue, router)
Vue.use(EditingGuard, { router })
Vue.use(whatsappHelper)
import store from './store'
import jQuery from 'jquery'
import vSelect from "vue-select"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import Axios from 'axios'
import Swal from 'sweetalert2'
import VueTheMask from 'vue-the-mask'
import "vue-select/dist/vue-select.css"
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import highcharts from 'highcharts'
import highchartsVue from 'highcharts-vue'
import VariablePie from "highcharts/modules/variable-pie"
import RotinaListaToolbar from '@/components/cadastros/RotinaListaToolbar.vue'
import CampoNumerico from '@/components/forms/CampoNumerico.vue'
import ValidatedField from '@/components/forms/ValidatedField.vue'
Vue.component('validated-field', ValidatedField)
import ValidationSummary from '@/components/forms/ValidationSummary.vue'
import RegistrationImage from '@/components/forms/RegistrationImage.vue'
Vue.component('validation-summary', ValidationSummary)
Vue.component('registration-image', RegistrationImage)

global.jQuery = jQuery
global.$ = jQuery

// Configurar Axios com withCredentials para enviar cookies automaticamente
Axios.defaults.withCredentials = true
Axios.defaults.headers.common['ngrok-skip-browser-warning'] = '69420'

// Sempre configura o header Authorization caso haja token salvo
const tokenDeStore = store.state.tokenSessao
if (tokenDeStore) {
   Axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenDeStore
}

// Sempre configura o header X-Company-Id caso haja empresa selecionada salva
const empresaDeStore = store.state.dadosEmpresa
if (empresaDeStore && empresaDeStore.id) {
   Axios.defaults.headers.common['X-Company-Id'] = empresaDeStore.id
}

Vue.prototype.$axios = Axios

// DEBUG (somente leitura): no console do navegador use  debugEstoque(produtoId [, limite])
window.debugEstoque = function (produtoId, limite) {
  const emp = store.state.empresa || store.state.dadosEmpresa
  return Axios.get(store.state.urlRest + 'stock/debug/produto/' + produtoId, {
    headers: { 'X-Company-Id': emp && emp.id },
    params: { limite: limite || 50 }
  }).then(function (r) {
    const d = r.data
    console.group('[ESTOQUE DEBUG] produto ' + produtoId)
    console.log('Estoque global (produto):', d.estoqueGlobalProduto, '| Soma dos locais:', d.somaSaldosLocais)
    console.log('Saldo atual por local:')
    console.table(d.saldosPorLocal)
    console.log('Movimentos fisicos (saldo por local antes/depois reconstruido):')
    console.table(d.movimentos)
    ;(d.lotes || []).forEach(function (l) {
      console.group('Lote ' + l.numeroLote + ' (id ' + l.loteId + ') saldo atual: ' + l.saldoAtual + ' | validade: ' + l.validade)
      console.table(l.movimentos)
      console.groupEnd()
    })
    console.groupEnd()
    return d
  }).catch(function (e) { console.error('[ESTOQUE DEBUG] erro', e) })
}
Vue.prototype.$toast = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})

Vue.directive('focus', {
   inserted: function (el) {
      try {
         if (!window.matchMedia("(pointer: coarse)").matches) {
            el.focus()
         }
      } catch (error) {
         console.log(error)
      }
   }
})

Vue.directive('permission', {
   inserted: function (el, binding, vnode) {
      const requiredRole = binding.value;
      if (!requiredRole) return;
      
      const user = vnode.context.$store.state.dadosUsuario;
      if (!user) {
         el.parentNode && el.parentNode.removeChild(el);
         return;
      }
      
      const roles = user.roles || [];
      
      let hasRole = roles.includes('COMPANY_ADMIN') || roles.includes(requiredRole);
      
      if (!hasRole) {
         el.parentNode && el.parentNode.removeChild(el);
      }
   }
})

require('@/assets/plugins/simplebar/simplebar.css')
require('@/assets/plugins/perfect-scrollbar/perfect-scrollbar.css')
require('@/assets/plugins/metisMenu/metisMenu.min.css')
require('@/assets/css/fontAwesome5Pro.css')
require('@/assets/css/bootstrap.min.css')
require('@/assets/css/app.css')
require('@/assets/css/icons.css')
require('@/assets/css/dark-theme.css')
require('@/assets/css/semi-dark.css')
require('@/assets/css/header-colors.css')

require('@/assets/plugins/metisMenu/metisMenu.min.js')
require('@/assets/js/bootstrap.bundle.min.js')
require('@/shared/selects/select.css')

VariablePie(highcharts)

Vue.use(highchartsVue)
Vue.use(VueTheMask)
Vue.component(Cropper)

vSelect.props.mapKeydown.default = mapearTeclasSelect
installSearchSelects(Vue, vSelect)

Vue.component('resumo-estoque-unidades', ResumoEstoqueUnidades)
Vue.directive('lancamento-limpavel', lancamentoLimpavel)
Vue.component('datePicker', DatePicker)
Vue.component('rotina-list-toolbar', RotinaListaToolbar)
Vue.component('campo-numerico', CampoNumerico)

// Padrao transversal das listagens: qualquer acao principal de inclusao no
// cabecalho recebe a identificacao visual e o atalho Insert. As telas novas
// usam data-shortcut-insert diretamente; o marcador abaixo cobre cadastros
// legados enquanto eles migram para RotinaListaToolbar.
const normalizarTextoAtalho = valor => String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()
const marcarBotoesInsert = () => {
   document.querySelectorAll('#search-nav button, .rotina-list-toolbar button').forEach(botao => {
      if (botao.closest('.modal') || !botao.querySelector('.fa-plus')) return
      const texto = normalizarTextoAtalho(botao.textContent).replace(/\[insert\]/g, '').trim()
      if (!/^(novo|nova|adicionar|incluir)(\s|$)/.test(texto)) return
      botao.setAttribute('data-shortcut-insert', '')
      botao.classList.add('rotina-global-insert-button')
      if (!botao.title) botao.title = `${botao.textContent.trim()} (Insert)`
   })
}
const agendarMarcacaoInsert = () => window.requestAnimationFrame(marcarBotoesInsert)
document.addEventListener('keydown', event => {
   const insert = event.key === 'Insert' || event.code === 'Insert' || event.keyCode === 45
   if (!insert || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey || document.querySelector('.modal.show')) return
   marcarBotoesInsert()
   const botao = Array.from(document.querySelectorAll('[data-shortcut-insert]')).find(item => !item.disabled && item.offsetParent !== null)
   if (!botao) return
   event.preventDefault()
   event.stopImmediatePropagation()
   botao.click()
}, true)
router.afterEach(() => Vue.nextTick(agendarMarcacaoInsert))
window.addEventListener('load', agendarMarcacaoInsert)
new MutationObserver(agendarMarcacaoInsert).observe(document.body, { childList: true, subtree: true })

Vue.config.productionTip = false

const queryParams = new URLSearchParams(window.location && window.location.search ? window.location.search : '')
const portalToken = queryParams.get('portalToken')
const rotaInicialNavegador = window.location && window.location.pathname ? window.location.pathname : ''
const explicitRoute = queryParams.get('route')
const lastPdvRoute = sessionStorage.getItem('last_pdv_route')

if (explicitRoute) {
   router.replace(explicitRoute).catch(() => { })
} else if (portalToken) {
   router.replace(`/portal/orcamento/${portalToken}`).catch(() => { })
} else if (rotaInicialNavegador.startsWith('/portal/orcamento/')) {
   router.replace(rotaInicialNavegador).catch(() => { })
} else if (lastPdvRoute) {
   router.replace(lastPdvRoute).catch(() => { })
}

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
